import React from 'react';

import classes from './SubSectionHeader.module.css'

const SubSectionHeader = ({ title,className='' }) => {
    return (
        <div className={`${classes['header-container']} ${className}`}>{title}</div>
    )
}

export default SubSectionHeader;